export const AGY_CLI_VERSION = '1.2.9';
